import { Typography } from "@lyfegen-platform/react-common";
import { Box, Button, Divider, withStyles } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import { blueContrast } from "../../hooks/use-map-theme-styles";
import { ChipFilterState, TableFilterAction } from "./models";
import { ClearPermanentFilterButton } from "./PermanentFilters";

const ChipButton = withStyles((theme) => ({
	root: {
		border: "none",
		padding: 0,
		paddingLeft: theme.spacing(1),
		height: "auto",
		textTransform: "none",
		width: "auto",
		"&:hover": {
			backgroundColor: "transparent",
			boxShadow: "none",
		},
	},
}))(Button);

const ChipFilter = (props: { filter: ChipFilterState; dispatcher: (action: TableFilterAction) => void }) => {
	const { t } = useTranslation();
	const isEmpty = !props.filter.isActive;
	function toggle(value: boolean) {
		props.dispatcher({
			type: "set-boolean-value",
			path: props.filter.field as string,
			value: value,
		});
	}
	function setFilter() {
		toggle(true);
	}

	function clear() {
		toggle(false);
	}

	const typographyStyles = isEmpty
		? {
				paddingLeft: "8px",
				cursor: "pointer",
		  }
		: {
				color: "#367bf5",
		  };

	return (
		<Box mb={3} pl={1.3}>
			<Box borderRadius="4px" style={{ border: `1px solid ${blueContrast}` }}>
				<Box display="flex" alignItems={"center"} height={"26px"} pr={1}>
					{!isEmpty && (
						<>
							<ClearPermanentFilterButton onClick={clear}>
								<Close color="primary" style={{ fontSize: "1.1rem" }} />{" "}
							</ClearPermanentFilterButton>
							<Divider orientation="vertical" style={{ marginRight: "8px", backgroundColor: blueContrast }} />
						</>
					)}
					<ChipButton onClick={setFilter}>
						<Typography
							style={{
								...typographyStyles,
								paddingRight: "8px",
							}}
						>
							{t(props.filter.localizationKey || (props.filter.field as string))}
						</Typography>
						{isEmpty
							? props.filter.icons?.iconOff && props.filter.icons?.iconOff()
							: props.filter.icons?.iconOn && props.filter.icons?.iconOn()}
					</ChipButton>
				</Box>
			</Box>
		</Box>
	);
};

export default ChipFilter;
